// extracted by mini-css-extract-plugin
module.exports = {"Quiz":"Quiz_Quiz__3UnfT","QuizWrapper":"Quiz_QuizWrapper__mjQPj"};